const retailConnectDictionaryMapping = {
  BusinessTypes: 'retail-Connect-Cart.Checkout.Labels.Trade-Label',
  IsB2B: 'product-Catalog.Retail.Trade.B2B',
  IsB2C: 'product-Catalog.Retail.Trade.B2C',

  DeliveryTypes: 'retail-Connect-Cart.Checkout.Labels.Delivery-Type',
  IsDeliveryToConstruction: 'product-Catalog.Retail.Delivery.Delivery-on-site',
  IsExpress: 'product-Catalog.Retail.Delivery.Express-shipping',
  IsNormal: 'product-Catalog.Retail.Delivery.Standard-Shipping',
  IsPickup: 'product-Catalog.Retail.Delivery.Pick-up',

  PaymentTypes: 'retail-Connect-Cart.Checkout.Labels.Payment-Type',
  IsCash: 'product-Catalog.Retail.Payment.Cash-payment',
  IsCreditCard: 'product-Catalog.Retail.Payment.Credit-card',
  IsDebitTransfer: 'product-Catalog.Retail.Payment.Transfer',
  IsEcCard: 'product-Catalog.Retail.Payment.EC-Card',
  IsIdeal: 'product-Catalog.Retail.Payment.Ideal',
  IsInvoice: 'product-Catalog.Retail.Payment.Bill',
  IsMobilePayment: 'product-Catalog.Retail.Payment.Mobile-Payment',
  IsPaymentInAdvance: 'product-Catalog.Retail.Payment.Prepayment',
  IsPaypal: 'product-Catalog.Retail.Payment.PayPal',
  IsDirectDebit: 'product-Catalog.Retail.Payment.Direct-debit',
};

const translationKeys = Object.keys(retailConnectDictionaryMapping).sort();

function retailConnectTranslation(value, $dict) {
  const translationKey = retailConnectDictionaryMapping[value];
  if (!translationKey) {
    // eslint-disable-next-line no-console
    console.log('Unknown facet', value);
    return value;
  }
  return $dict.get(translationKey);
}

export { retailConnectTranslation, translationKeys };
export default retailConnectTranslation;
